// src/components/ConfirmationScreen.jsx
import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import Lottie from "lottie-react";
import successAnimation from "../animation/success.json";
import "./ConfirmationScreen.css";

export default function ConfirmationScreen() {
  return (
    <Box className="confirm-wrapper">
      <Paper className="confirm-card" elevation={0}>
        <Lottie
          className="confirm-lottie"
          animationData={successAnimation}
          loop={false}
        />

        <Typography variant="h5" className="confirm-title">
          Your booking has been sent!
        </Typography>

        <Typography variant="body2" className="confirm-subtitle">
          Your ride details have been shared with the driver.<br/> You’ll receive a confirmation message once the driver accepts the
          booking.
        </Typography>
      </Paper>
    </Box>
  );
}
